import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { ICONS } from '../../data/programs';
import '../../styles/components/landing/FeaturesSection.css';

const FeaturesSection = ({ eyebrow, title, subtitle, items = [] }) => {
  return (
    <section id="features" className="ls-features">
      <div className="container">
        <div className="ls-features__header">
          {eyebrow && <span className="ls-features__eyebrow">{eyebrow}</span>}
          <h2 className="ls-features__title">{title}</h2>
          {subtitle && <p className="ls-features__subtitle">{subtitle}</p>}
        </div>

        <div className="ls-features__grid">
          {items.map((item, i) => {
            const Icon = ICONS[item.icon] || ICONS.Sparkles;
            return (
              <motion.div
                key={i}
                className={`ls-features__card ls-features__card--${item.color || 'primary'}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
              >
                <div className="ls-features__icon">
                  <Icon size={22} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                {item.bullets && (
                  <ul>
                    {item.bullets.map((b, j) => (
                      <li key={j}>
                        <CheckCircle2 size={16} />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
